import React from 'react';
import { Route } from 'react-router';
import { ApplicationPaths } from './constants';
import Login from './Login';
import Logout from './Logout';
function AuthRoutes() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Route, { exact: true, path: ApplicationPaths.Login, component: Login }),
        React.createElement(Route, { exact: true, path: ApplicationPaths.Logout, component: Logout })));
}
export default AuthRoutes;
